import { Assets, Texture } from 'pixi.js';

export const AssetKeys = {
  BgFar: 'bg-far',
  BgMid: 'bg-mid',
  BgFore: 'bg-fore',
  TreeDecor: 'tree-decor',
  BenjiHold: 'benji-hold',
  BenjiJump: 'benji-jump',
  Vine: 'vine',
  VineRotated: 'vine-rotated',
  Leaf: 'leaf',
} as const;

const MANIFEST: Record<string, string> = {
  [AssetKeys.BgFar]: '/sprites/bg.webp',
  [AssetKeys.BgMid]: '/sprites/bush.webp',
  [AssetKeys.BgFore]: '/sprites/grace_bottom.webp',
  [AssetKeys.TreeDecor]: '/sprites/tree.webp',
  [AssetKeys.BenjiHold]: '/sprites/monkey_hold.png',
  [AssetKeys.BenjiJump]: '/sprites/monkey_jump.png',
  [AssetKeys.Vine]: '/sprites/liana.webp',
  [AssetKeys.Leaf]: '/sprites/leaf.webp',
};

export async function loadAllAssets(): Promise<Record<string, Texture>> {
  const entries = Object.entries(MANIFEST);
  for (const [alias, src] of entries) Assets.add({ alias, src });
  const result = await Assets.load(entries.map(([k]) => k));
  return Object.fromEntries(entries.map(([alias]) => [alias, result[alias] as Texture]));
}
